import styles from "./GridCard.module.scss";

interface Props {
  title: string;
  tag?: string;
  mainImage?: string;
}

const GridCard = (props: Props) => {
  return (
    <>
      <div className={styles.gridCard}>
        <div className={styles.gridCard__tag}>
          {props.tag ? (
            <p className={styles.gridCard__tag__label}>{props.tag}</p>
          ) : (
            <> </>
          )}
        </div>
        <div className={styles.gridCard__mainImageContainer}>
          {props.mainImage ? (
            <img
              className={styles.gridCard__mainImageContainer__mainImage}
              src={props.mainImage}
              alt={props.title}
            />
          ) : (
            <> </>
          )}
        </div>
        <div className={styles.gridCard__title}>{props.title}</div>
      </div>
    </>
  );
};

export default GridCard;
